export default {"src":"/_next/static/media/logo-bunqer.1964dcd7.svg","height":247,"width":595,"blurWidth":0,"blurHeight":0};